module.exports = new __parcel__URL__("storm.aef36c72.svg").toString();